const titles = document.getElementsByClassName('accordion__title');

for (let i = 0; i < titles.length; i++) {
    titles[i].addEventListener('click', function(event) {
        const target = event.target as Element;

        target.classList.toggle('accordion__title--active');
    });
}
